(function(angular) {
    'use strict';

    angular.module('onvio.setup.appearance').factory('ThemeSetupManager', themeSetupManager);
    themeSetupManager.$inject = ['$q', '$http', '$translate', 'AuthenticatedSessionData', 'bmEnvironment'];

    function themeSetupManager($q, $http, $translate, sessionData, bmEnvironment) {
        var deferredAppConfig;
        var backgrounds = [
            {
                name: 'grass',
                active: true
            },
            {
                name: 'tulips',
                active: false
            },
            {
                name: 'wheat',
                active: false
            },
            {
                name: 'weeds',
                active: false
            },
            {
                name: 'blossoms',
                active: false
            },
            {
                name: 'fall',
                active: false
            },
            {
                name: 'winter',
                active: false
            },
            {
                name: 'sunflowers',
                active: false
            }
        ];

        var factory = {
            getDefaultThemeSettings: getDefaultThemeSettings,
            getFirmThemeSettings: getFirmThemeSettings,
            getFormattedColorScheme: getFormattedColorScheme,
            saveTheme: saveTheme,
            getFormattedLoginHtml: getFormattedLoginHtml,
            getApplicationRootUrl: getApplicationRootUrl,
            signInBackgrounds: backgrounds
        };

        var serviceUri = '/api/profiles/v1/themes';

        var cannedColors = [
            {
                headerFillColor: '#FFFFFF',
                headerTextColor: '#606060',
                buttonFillColor: '#f39518',
                buttonTextColor: '#FFFFFF'
            },
            {
                headerFillColor: '#FFFFFF',
                headerTextColor: '#003565',
                buttonFillColor: '#003565',
                buttonTextColor: '#FFFFFF'
            },
            {
                headerFillColor: '#FFFFFF',
                headerTextColor: '#0a8F08',
                buttonFillColor: '#0A8F08',
                buttonTextColor: '#FFFFFF'
            },
            {
                headerFillColor: '#2B3C70',
                headerTextColor: '#FFFFFF',
                buttonFillColor: '#D4DADF',
                buttonTextColor: '#2B3C70'
            },
            {
                headerFillColor: '#E9E9E9',
                headerTextColor: '#000000',
                buttonFillColor: '#C8C356',
                buttonTextColor: '#FFFFFF'
            }
        ];

        ///////////

        function getDefaultThemeSettings(companyId) {
            var themeData = {};

            // TODO: THIS WILL BE LOADED FROM WEB SERVICE
            return $http(getHttpRequestConfig('/presets?company=' + companyId, 'GET')).then(function(response) {
                if (angular.isDefined(response.data)) {
                    // use canned for now
                    // themeData.colorSchemes = formatColorOptions(response.data.colors);
                    themeData.colorSchemes = formatColorOptions(cannedColors);
                    themeData.defaultHeaderText = formatHeaderText(response.data.headerLine1, response.data.headerLine2, response.data.headerLine3);
                }

                return themeData;
            }, function() {
                themeData.colorSchemes = formatColorOptions(cannedColors);
                themeData.defaultHeaderText = formatHeaderText();

                return themeData;
            });
        }

        function getFirmThemeSettings(companyId) {
            // TODO: HOW TO HANDLE ERRORS ON A REJECT?
            return $http(getHttpRequestConfig('?company=' + companyId, 'GET')).then(function(response) {
                return response.data;
            }, function() {
                return undefined;
            });
        }

        function getFormattedColorScheme(id, color) {
            if (angular.isUndefined(id) || angular.isUndefined(color)) {
                return color;
            }

            var currentColor = {};
            currentColor.id = id;
            currentColor.value = 'theme' + id;
            currentColor.headerFill = { 'background-color': color.headerFillColor.toLowerCase() };
            currentColor.headerText = { 'background-color': color.headerTextColor.toLowerCase() };
            currentColor.buttonFill = { 'background-color': color.buttonFillColor.toLowerCase() };
            currentColor.buttonText = { 'background-color': color.buttonTextColor.toLowerCase() };
            return currentColor;
        }

        function saveTheme(companyId, theme) {
            // TODO: HOW TO HANDLE ERRORS ON A REJECT?
            return $http(getHttpRequestConfig('?company=' + companyId, 'PUT', theme)).then(function(response) {
                return response.data;
            }, function() {
                return undefined;
            });
        }

        ///////////

        function formatColorOptions(colors) {
            if (angular.isUndefined(colors) || colors.length === 0) {
                colors = cannedColors;
            }

            var formattedColors = [];
            var currentColor;

            for (var counter = 0; counter < colors.length; counter++) {
                currentColor = getFormattedColorScheme(counter + 1, colors[counter]);

                if (angular.isDefined(currentColor)) {
                    formattedColors.push(currentColor);
                }
            }

            return formattedColors;
        }

        function formatHeaderText(line1, line2, line3) {
            var headerText = {};
            headerText.lineOne = angular.isUndefined(line1) ? '' : line1;
            headerText.lineTwo = angular.isUndefined(line2) ? '' : line2;
            headerText.lineThree = angular.isUndefined(line3) ? '' : line3;
            return headerText;
        }

        function getHttpRequestConfig(restServiceMethod, requestType, requestData) {
            if (restServiceMethod === null || angular.isUndefined(restServiceMethod) || requestType === null || angular.isUndefined(requestType)) {
                return null;
            }

            var config = {};
            config.method = requestType.toUpperCase();
            config.url = serviceUri + restServiceMethod;
            config.cache = false;
            config.headers = {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true',
                'Accept': 'application/json'
            };

            if (requestData !== null && angular.isDefined(requestData)) {
                config.data = requestData;
            }

            return config;
        }

        function getApplicationRootUrl() {
            var root = 'https://onvio.us';

            return getApplicationBindings().then(function(bindings) {
                if (angular.isString(bindings.RoutingTable.Root)) {
                    root = bindings.RoutingTable.Root;
                }

                return root;
            }, function() {
                return root;
            });
        }

        function getApplicationBindings() {
            if (angular.isUndefined(deferredAppConfig)) {
                deferredAppConfig = $q.defer();
                sessionData.get().then(function(data) {
                    deferredAppConfig.resolve(data.bindings);
                }, function() {
                    deferredAppConfig.reject();
                });
            }

            return deferredAppConfig.promise;
        }

        function commonSiginStyle(scope, accentColor, buttonFontColor) {
            return '  .onvio' + scope + '-sign-in {\r\n' +
                   '    display: flex; align-items: center; justify-content: center; flex-direction: column;\r\n' +
                   '    width: 300px; height: 184px;\r\n' +
                   '    border-radius: 10px; border: solid 2px #d5d4d9;\r\n' +
                   '    background-color: white;\r\n' +
                   '  }\r\n' +
                   '  \r\n' +
                   '  .onvio' + scope + '-sign-in span {\r\n' +
                   '    font-family: Arial; font-size: 24px; font-weight: bold; color: #212121; margin-bottom: 25px;\r\n' +
                   '  }\r\n' +
                   '  \r\n' +
                   '  .onvio' + scope + '-sign-in a {\r\n' +
                   '    width: 150px; height: 46px;\r\n' +
                   '    border-radius: 5px; border: solid 1px ' + (accentColor || '#b2b2b8') + ';\r\n' +
                   '    background-color: ' + (accentColor || '#f4f5f7') + ';\r\n' +
                   '    text-align: center; vertical-align: middle; line-height: 46px;\r\n' +
                   '    font-family: Arial; font-size: 14px; font-weight: bold; letter-spacing: 1.1px;\r\n' +
                   '    text-align: center;\r\n' +
                   '  }\r\n' +
                   '  .onvio' + scope + '-sign-in a, .onvio' + scope + '-sign-in a:hover,\r\n' +
                   '  .onvio' + scope + '-sign-in a:focus, .onvio' + scope + '-sign-in a:visited, .onvio' + scope + '-sign-in a:active {\r\n' +
                   '    text-transform: uppercase;\r\n' +
                   '    text-decoration: none;\r\n' +
                   '    color: ' + (buttonFontColor || '#212121') + ';\r\n' +
                   '  }\r\n' +
                   '  \r\n' +
                   '  .onvio' + scope + '-sign-in a:hover {\r\n' +
                   '    border: solid 1px ' + (accentColor || '#b2b2b8') + '; background-color: ' + (accentColor || '#FFFFFF') + ';\r\n' +
                   '  }\r\n';
        }

        function onvioSignInCode(rootUrl, sigInText, appText) {
            return '<style>\r\n' + commonSiginStyle('') + '</style>\r\n' +
                   '<div class="onvio-sign-in">\r\n' +
                   '    <span>' + appText + '</span>\r\n' +
                   '    <a rel="external noopener noreferrer" href="' + rootUrl + '" target="_blank">' + sigInText + '</a>\r\n' +
                   '</div>\r\n';
        }

        function clientCenterSignInCode(clientCenterUrl, accentColor, sigInText, appText) {
            return '<style>\r\n' + commonSiginStyle('-client', accentColor, '#ffffff') + '</style>\r\n' +
                   '<div class="onvio-client-sign-in">\r\n' +
                   '    <span>' + appText + '</span>\r\n' +
                   '    <a style="outline: none" rel="external noopener noreferrer" href="' + clientCenterUrl + '" target="_blank">' + sigInText + '</a>\r\n' +
                   '</div>\r\n';
        }

        function getFormattedLoginHtml(){
            var promises = [
                $translate('onvio.appearance.html.signIn'),
                $translate('onvio.setup.appearance.signinForm.staff'),
                $translate('onvio.setup.appearance.signinForm.client'),
                getApplicationBindings(),
                bmEnvironment.getEnvironmentAsync(),
                getApplicationRootUrl(),
            ];

            return $q.all(promises)
                .then(function(values) {
                    var companyId = values[3].ApplicationConfiguration.CompanyId;
                    var countryCode = values[4].countryCode;
                    var rootUrl = values[5];
                    return getFirmThemeSettings(companyId).then(function(theme) {
                        return {
                            theme: theme,
                            rootUrl: rootUrl,
                            texts: [values[0], values[1], values[2]],
                            clientCenterUrl: getClientCenterUrl(countryCode, rootUrl, companyId)
                        };
                    });
                }).then(function(values) {
                    return {
                        staff: onvioSignInCode(values.rootUrl, values.texts[0], values.texts[1]),
                        client: clientCenterSignInCode(values.clientCenterUrl, values.theme.colors.buttonFillColor, values.texts[0], values.texts[2])
                    };
            });
        }

        function getClientCenterUrl(countryCode, rootUrl, companyId) {
            var url;
            switch (countryCode) {
                case 'BR':
                    url = rootUrl;
                    break;
                default:
                    url = rootUrl + '/clientcenter/company/' + companyId;
            }
            return url;
        }

        return factory;
    }
})(window.angular);
